<template>
  <Modal :id="'.cmp-booking-release-add-link    '" @cancelled="onCancel">
    <template slot="header">{{$t('add')}} {{$t('preset')}}</template>
    <template slot="body">
  
        <TextField
          class="m1"
          :id="'preset_name'"
          
          v-bind="textFieldConfig"
        
          :value="preset_name"
          :placeholder="$t('preset_name')"
          @valuechanged="onTextFieldValueChange"
          
        />
        <TextField
          class="m1"
          :id="'notes'"
          
          v-bind="textAreaConfig"
        
          :value="notes"
          :placeholder="$t('name')"
          @valuechanged="onTextFieldValueChange"
          
        />


    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onAddLink">{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import { CountriesTV } from "../../../../models/country.model";
import { Subject } from "rxjs";

import { createTextFieldConfig, EventHooks } from "../../../../plugins/text-field";
import { subscribeSubject } from "../../../../utility";
import { findCountryOfCity } from "../../../../dt-plugins/country";

import Modal from "@dtplugins/modal/modal";

export default {
  components: {
    Modal
  },
  props: {},
  data: function() {
    return {
      preset_name:"",
      notes:"",

      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,

        valueChangedEvent: EventHooks.OnKeyup
      }),
       textAreaConfig: {
        height: 120,
        showEditIconOnHover: false,
        box: true,
        textarea: true,
        showValidationIcons: false
      },
   

     
      locations: []
      // Mark: Data
    };
  },
  mounted: function() {
   
  },
  watch: {},
  computed: {
    //   external_id: function() {
    //   return this.$route.query.external_id;
    // },
    channel:function(){
      return this.$route.query.digital_physical;
    }
  },
  methods: {
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this[key]=value
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onAddLink: function() {
      let columns =[ ];
      const emptyArray=[...Array(100).keys()].map(x=>{
          return '';
      })

      if(this.channel=='digital'){
        columns =
          [ 
            "si_label", "ds_artist", "ds_title", "ds_barcode", "ds_isrc", "ds_sales","ds_country", "ds_usage_type",
            "ds_shop", "ds_ppu", "ds_ppu_total", "", "ds_product_identifier", "ds_bundle_track", "si_currency","si_currency_amount"
          ]

      }else if(this.channel=='physical'){
        columns = [ "si_label","ps_artist","ps_title","ps_catalog_no"]

      }else if(this.channel=='thirdparty'||this.channel=='performance'){
        columns =["ds_isrc","ds_artist","ds_title","ds_info","ds_ppd"]
      }else{
        columns = [...emptyArray]
      }

      const final_columns = [ ...columns ,  ...[...Array(100-columns.length).keys()].map(x=>{
          return '';
      })]

     
      const payload= { 
          notes:this.notes, 
          preset_name:this.preset_name , 
          digital_physical:this.channel,
          column_headers_json_str:final_columns
        }  
      this.$emit("create", payload);
    },


    // Mark: Methods
  }
};
</script>

<style lang="scss">
.cmp-booking-release-add-link {
  .location-list-container {
    width: 100%;
    // height: 190px;
    // overflow: auto;

    table {
      margin-top: 10px;
      width: 100%;

      tbody {
        max-height: 190px;
        overflow: auto;
        min-height: 190px;

        tr {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
